import React from 'react'
import Navbar from '../components/Navbar'

export default function Home() {
  return (
    <div>
        <Navbar />
    </div>
  )
}
